module.exports = __webpack_public_path__ + "img/gentry-of-hermitage-3.33b269aa.webp";